import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'freemium-ui';
import Icon from 'components/Icons';

const FieldLabel = props => {
  const {
    label,
    name,
    className,
    optionalTxt,
    tipTxt,
    labelInfo,
    tipPosition
  } = props;
  return (
    <Fragment>
      <label htmlFor={name} className={`${className} fs-label`}>
        {label}
        {labelInfo ? (
          labelInfo
        ) : tipTxt ? (
          <span
            style={{ top: '3px', position: 'relative', paddingLeft: '5px' }}
          >
            <Tooltip theme="light" label={tipTxt} position={tipPosition}>
              <Icon size={14} viewBox="0 0 12 10" glyph="info" />
            </Tooltip>
          </span>
        ) : null}

        {optionalTxt ? (
          <span style={{ color: '#737373' }}> ({optionalTxt})</span>
        ) : null}
      </label>
    </Fragment>
  );
};

const StyledFieldLabel = styled(FieldLabel)`
  padding-bottom: 8px;
  padding-left: 2px;
  /* text-transform: capitalize; */
  font-size: 12px;
  font-weight: 500;
  color: #1f394c;
`;

export default StyledFieldLabel;
